import { Button as FoundationsButton } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
export const OverflowButton = ({
  as: Button,
  onClick,
  overflowCount,
  'data-test-id': dataTestId,
  buttonProps
}) => {
  return /*#__PURE__*/_jsx(Button, Object.assign({}, buttonProps, {
    children: /*#__PURE__*/_jsx(FoundationsButton, {
      use: "transparent",
      onClick: onClick,
      "data-test-id": dataTestId,
      padding: "0",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "calendar.event.revealMoreEventsLink",
        options: {
          numberOfEventsToReveal: I18n.formatNumber(overflowCount)
        }
      })
    })
  }));
};